Revolution.Module.extend({
    NAME: "mde.tooltip", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/compatibility.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.initTooltip();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    initTooltip: function () {
        $('.js-tooltip').each(function (index, elem) {
            var title = $(elem).data('title');
            var desc = $(elem).attr('title');
            var htmlContent = '<span class="tt-desc">'+ desc +'</span>';

            if (title != undefined) {
                htmlContent = '<strong class="tt-title">'+title +'</strong>' + htmlContent;
            }

            $(elem).tooltipster({
                content: $(htmlContent)
            });
        });
    }

});
